<!--
 * File: AppCard.vue
 * Project: timo
 * File Created: Monday, 21st September 2020 6:44:31 pm
 * Author: Timo Zacherl
 * License: MPL-2.0
 * 
 * -----
 * Last Modified: Thursday, 24th September 2020 9:27:36 pm
 * Modified By: Timo Zacherl
 * -----
 * 
 * Copyright © 2020 Timo Zacherl. All rights reserved.
-->

<template>
  <div class="app-card">
    <router-link class="app-card-link" :to="routerLink">
      <figure class="app-entity">
        <img class="app-icon" :src="getImgUrl()" />
        <figcaption>
          <h2>Gitimoji</h2>
          <h3>Gitmoji on your Mac</h3>
        </figcaption>
      </figure>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "AppCard",
  props: {
    appIcon: String,
    routerLink: String
  },
  methods: {
    getImgUrl() {
      var images = require.context("../assets/", false, /\.png$/);
      return images("./" + this.appIcon + ".png");
    }
  }
};
</script>

<style lang="scss" scoped>
.app-card {
  background-color: hsla(0, 0%, 14%, 0.95);
  background: linear-gradient(
    to left,
    hsla(0, 0%, 14%, 0.95) 50%,
    hsla(0, 0%, 19%, 0.95) 50%
  );
  background-size: 200% 100%;
  background-position: right bottom;
  height: 300px;
  border-radius: 1rem;
  text-align: center;
  transition: 0.2s ease;
  position: relative;

  @media screen and (max-width: 960px) {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .app-card-link {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    border-bottom: none;

    .app-entity {
      z-index: 2;

      .app-icon {
        width: 128px;
        height: 128px;
      }

      figcaption {
        h2 {
          color: #fff;
          margin: 0;
          margin-bottom: 0.5rem;
        }
        h3 {
          color: darken($color: #fff, $amount: 20);
          margin: 0;
        }
      }
    }
  }

  &.is-big {
    height: 500px;

    @media screen and (max-width: 659px) {
      height: 300px;
    }

    .app-card-link {
      .app-entity {
        .app-icon {
          width: 192px;
          height: 192px;

          @media screen and (max-width: 659px) {
            width: 126px;
            height: 126px;
          }
        }

        figcaption {
          h2 {
            font-size: 2.25rem;

            @media screen and (max-width: 659px) {
              font-size: 1.3rem;
              font-weight: 700;
              letter-spacing: 0.01rem;
            }
          }

          h3 {
            font-size: 1.75rem;

            @media screen and (max-width: 659px) {
              font-size: 1.2rem;
              font-weight: 400;
              letter-spacing: 0.01rem;
              margin-top: 0.2rem;
            }
          }
        }
      }
    }
  }

  &:hover {
    background-position: left bottom;

    .app-icon {
      animation: app-icon-jump 10 0.6s ease;
    }
  }
}

@keyframes app-icon-jump {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-5px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>
